import { HomeOutlined } from '@ant-design/icons'
import { Breadcrumb as AntBreadcrumb } from 'antd'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { TRANSITIONS } from '@/shared/constants/transitions'
import { useThemeColors } from '@/shared/hooks/useThemeColors'
import { BreadcrumbProps } from '@/types/layout'

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ segments, className = '' }) => {
  const navigate = useNavigate()
  const colors = useThemeColors()

  if (segments.length === 0) {
    return null
  }

  const items = segments.map((segment, index) => ({
    title: segment.isActive ? (
      <span style={{ 
        color: colors.primaryHover, 
        fontWeight: 500,
        transition: TRANSITIONS.COLOR
      }}>
        {segment.label}
      </span>
    ) : (
      <a
        onClick={(e) => {
          e.preventDefault()
          navigate(segment.path)
        }}
        style={{ 
          color: colors.textSecondary,
          transition: TRANSITIONS.COLOR,
          cursor: 'pointer'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.color = colors.primaryHover
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = colors.textSecondary
        }}
      >
        {index === 0 && <HomeOutlined style={{ marginRight: 4 }} />}
        {segment.label}
      </a>
    ),
  }))

  return (
    <AntBreadcrumb
      items={items}
      className={className}
      separator="/"
      style={{
        fontSize: '14px'
      }}
    />
  )
}

export default Breadcrumb
